import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { map, Observable } from 'rxjs';
import { AuthenticationModel, Rights } from '../services/api-services';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  constructor(private readonly router: Router,
    private readonly authenticationService: AuthenticationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    if (this.authenticationService.getToken()) {
      if (!this.authenticationService.tokenExpired()) {
        return this.handleToken(next);
      }
      else {
        return this.authenticationService.refreshToken()
          .pipe(map((model: AuthenticationModel | null) => {
            if (model?.token) {
              // token will be set in authenticationservice already
              return this.handleToken(next);
            }
            else {
              this.redirectToLogin(state);
              return false;
            }
          }));
      }
    }
    else {
      this.redirectToLogin(state);
      return false;
    }
  }

  private redirectToLogin(state: RouterStateSnapshot): void {
    if (state.url == "/tools/businessplan" || state.url == "/tools/business-model-canvas") {
      this.router.navigate([this.authenticationService.getLoginAuthorizationWallUrl()], { queryParams: { redirectUrl: state.url } });
    }
    else {
      this.router.navigate([this.authenticationService.getLoginUrl()], { queryParams: { redirectUrl: state.url } });
    }
  }

  private handleToken(next: ActivatedRouteSnapshot): boolean {
    const userRights = this.authenticationService.getRights();

    if (userRights) {
      if (next.data['rights'] && !next.data['rights'].some((r: Rights) => userRights.includes(r))) {
        this.router.navigate(['/access-denied']);

        return false;
      }
    }
    else {
      return false;
    }

    return true;
  }
}
